import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import { useUserContext } from "@/context/UserContext";

import Loader from "@/components/loader";

const LoginCallback = () => {
  const code = new URLSearchParams(window.location.search).get("code");
  const codeVerifier = localStorage.getItem("pkce_verifier");
  const navigate = useNavigate();

  const { setToken } = useUserContext();

  if (code) {
    fetch(`${import.meta.env.VITE_BASE_URL}/auth/callback`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code, codeVerifier }),
    })
      .then((res) => res.json())
      .then((data) => {
        localStorage.setItem("token", data.id_token);
        setToken(data.id_token);
        if (data.refresh_token) {
          localStorage.setItem("refresh_token", data.refresh_token);
        }

        try {
          const decodedIdToken = jwtDecode(data.id_token);

          if (decodedIdToken && typeof decodedIdToken === "object") {
            const { email, user_id: userId } = decodedIdToken;
            if (typeof email === "string") {
              localStorage.setItem("email", email);
            }
            if (typeof userId === "string" || typeof userId === "number") {
              localStorage.setItem("userId", String(userId));
            }

            const profileClaim = decodedIdToken.profile;
            let role = "Farmer";

            if (Array.isArray(profileClaim)) {
              role = profileClaim[0] || role;
            } else if (typeof profileClaim === "string") {
              try {
                const parsedProfile = JSON.parse(profileClaim);
                if (Array.isArray(parsedProfile)) {
                  role = parsedProfile[0] || role;
                } else if (typeof parsedProfile === "string") {
                  role = parsedProfile;
                }
              } catch (profileErr) {
                console.warn("Failed to parse profile claim:", profileErr);
              }
            }

            if (typeof decodedIdToken.role === "string") {
              role = decodedIdToken.role;
            }

            localStorage.setItem("role", role);
          } else {
            localStorage.setItem("role", "Farmer");
          }
        } catch (decodeErr) {
          console.error("Failed to decode login token:", decodeErr);
          localStorage.setItem("role", "Farmer");
        }

        navigate("/home");
      });
  }

  return <Loader />;
};

export default LoginCallback;
